'use strict';

(function () {
  angular.module('specsguardApp').controller('EditAreaTemplateCtrl', EditAreaTemplateCtrl);

  EditAreaTemplateCtrl.$inject = [
    '$mdDialog',
    'errorMessageService',
    'Labels',
    'Constants',
    'AreaTemplateAPI',
    'areaTemplates'];

  function EditAreaTemplateCtrl (
    $mdDialog, errorMessageService, Labels, Constants,
    AreaTemplateAPI, areaTemplates) {

    const vm = this;
    vm.areaTemplates = areaTemplates;

    vm.FUNCTIONALITIES = Constants.getList('FUNCTIONALITIES');
    vm.parents = vm.areaTemplates.filter((template) => template.isParent);
    vm.LABELS = Labels;

    // Send user to add sheet area
    vm.submitNewAreaTemplate = (addanother) => {
      if (vm.form.$valid) {
        if (vm.model._id) {
          // Do an update
          AreaTemplateAPI.update({
            areaTemplate: vm.model,
            _id: vm.model._id
          }).$promise.then(function (updatedTemplates) {
            errorMessageService.showSuccess(Labels.getLabel('saved'));
            $mdDialog.hide(updatedTemplates);
          }).catch(function () {
            errorMessageService.showError(Labels.getLabel('saveerror'));
          });
        } else {
          // Or create a new one
          AreaTemplateAPI.create({areaTemplate: vm.model}).$promise.then((updatedTemplates) => {
            errorMessageService.showSuccess(Labels.getLabel('saved'));
            if (!addanother) {
              $mdDialog.hide(updatedTemplates);
            } else {
              resetForm();
            }
          }).catch(() => {
            errorMessageService.showError(Labels.getLabel('saveerror'));
          });
        }
      }
    };

    // Cancel dialog
    vm.cancel = (updatedProject, redirectUrl) => {
      $mdDialog.cancel();
    };

    vm.$onInit = function () {
      if (vm.model) {
        // make a copy so we can proxy changes and apply them only if save is pressed
        vm.model = angular.copy(vm.model);
        // have to do some translastions
        if (!angular.isObject(vm.model.functionality)) {
          vm.model.functionality = {_id: vm.model.functionality};
        }

        if (!angular.isObject(vm.model.parentId)) {
          vm.model.parentId = {_id: vm.model.parentId};
        }
      } else {
        vm.model = {
          name: '',
          isParent: true,
          copyData: false,
          parentId: {},
          functionality: { _id: vm.FUNCTIONALITIES[0]._id }
        };
      }
    };
    
    function resetForm() {
      vm.model.name = '';
      vm.form.$setPristine(true);
      vm.form.$setUntouched(true);
    }
  }
})();
